// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"prequal_wrapper__7wk3P","title":"prequal_title__VZ0HR","footer":"prequal_footer__u_HTj","tooltipNote":"prequal_tooltipNote__Lrjxf","submitBtn":"prequal_submitBtn__LFk6t"};